import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="bg-white min-h-screen p-8 space-y-16">

      {/* Header */}
      <div className="text-center space-y-4">
        <h1 className="text-4xl font-extrabold text-purple-400 text-center">Privacy Policy</h1>
        <p className="text-lg text-gray-700">
          Million2Trillion (M2T) is committed to protecting your privacy and personal data under global privacy regulations.
        </p>
      </div>

      {/* Privacy Policy Content */}
      <div className="max-w-5xl mx-auto border border-purple-100 bg-white p-8 rounded-2xl shadow space-y-6 text-gray-700 text-lg">

        <h2 className="text-2xl font-bold text-purple-400">Information We Collect</h2>
        <ul className="list-disc space-y-3 pl-6">
          <li>Personal information (name, address, phone, ID, documents)</li>
          <li>Financial details (payment information, tax details, billing history)</li>
          <li>Trading and service history (signal purchases, educational access, platform activity)</li>
          <li>Device information, IP address, location data (for compliance & fraud prevention)</li>
          <li>Cookies, analytics, session data (used for improving user experience and performance)</li>
        </ul>

        <h2 className="text-2xl font-bold text-purple-400">How We Use Your Data</h2>
        <ul className="list-disc space-y-3 pl-6">
          <li>To verify your identity and maintain platform security</li>
          <li>To deliver services, content, educational products, and financial tools</li>
          <li>To handle transactions, commissions, payouts, and invoicing</li>
          <li>To comply with global regulations including AML, KYC, tax and government reporting</li>
          <li>To monitor system abuse, protect against fraud, and enforce platform rules</li>
          <li>To improve user experience through personalization and content recommendation engines</li>
        </ul>

        <h2 className="text-2xl font-bold text-purple-400">Data Storage & Protection</h2>
        <ul className="list-disc space-y-3 pl-6">
          <li>All personal data is encrypted, securely stored, and access-limited internally</li>
          <li>We utilize secure cloud infrastructures that comply with international data protection regulations</li>
          <li>Security protocols include firewalls, multi-factor authentication, data access logging, and encryption at rest</li>
        </ul>

        <h2 className="text-2xl font-bold text-purple-400">Data Sharing & Third Parties</h2>
        <ul className="list-disc space-y-3 pl-6">
          <li>We do not sell your personal information</li>
          <li>Third-party services used for payments, KYC, compliance or fraud prevention may access limited information strictly for service delivery</li>
          <li>We share data only where required by law or regulatory obligations</li>
        </ul>

        <h2 className="text-2xl font-bold text-purple-400">Your Privacy Rights</h2>
        <ul className="list-disc space-y-3 pl-6">
          <li>Right to access your data</li>
          <li>Right to correct inaccurate data</li>
          <li>Right to request deletion ("right to be forgotten")</li>
          <li>Right to restrict processing</li>
          <li>Right to data portability</li>
          <li>Right to object to automated profiling or decision making</li>
        </ul>

        <h2 className="text-2xl font-bold text-purple-400">Retention Period</h2>
        <p>
          We retain personal data as long as legally required for platform operations, financial reporting, tax compliance, and regulatory audits.
        </p>

        <h2 className="text-2xl font-bold text-purple-400">International Transfers</h2>
        <p>
          Your data may be processed in servers located globally. We ensure cross-border compliance under GDPR, CCPA, and global privacy treaties.
        </p>

        <h2 className="text-2xl font-bold text-purple-400">Contact Our Privacy Team</h2>
        <p>
          You may contact us for privacy-related inquiries at:<br />
          <span className="font-semibold text-blue-700">privacy@million2trillion.com</span>
        </p>

      </div>



    </div>
  );
}
